import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { getAuthority } from './auth';

const { VITE_COMPANION_CLIENT_ID } = import.meta.env;

// Singleton UserManager instance shared across the application
let userManagerInstance: UserManager | null = null;

export const getUserManager = (): UserManager => {
  if (!userManagerInstance) {
    userManagerInstance = new UserManager({
      authority: getAuthority(),
      client_id: VITE_COMPANION_CLIENT_ID as string,
      redirect_uri: `${window.location.origin}/callbackSignIn`,
      scope: `openid profile offline_access napsterai.companions.identity.main`,
      post_logout_redirect_uri: `${window.location.origin}/callbackSignOut`,
      userStore: new WebStorageStateStore({ store: window.localStorage }),
    });
  }
  return userManagerInstance;
};

